import React, { createContext, useContext, useId } from "react";
import { createPortal } from "react-dom";

interface TooltipPortalContextProps {
	elementId: string;
}

const TooltipPortalContext = createContext<TooltipPortalContextProps | null>(
	null,
);

export interface TooltipPortalProviderProps {
	children?: React.ReactNode;
}

/**
 * Creates the tooltip portal target element and exposes its ID to TooltipPortal.
 */
export function TooltipPortalProvider(props: TooltipPortalProviderProps) {
	const elementId = useId();

	return (
		<TooltipPortalContext value={{ elementId }}>
			{props.children}
			<div id={elementId} />
		</TooltipPortalContext>
	);
}

export interface TooltipPortalProps {
	children?: React.ReactNode;
}

/**
 * Renders children into the TooltipPortalProvider target element,
 * escaping ancestor overflow clipping and inherited styles
 * (e.g. text-transform from table headers).
 */
export default function TooltipPortal(props: TooltipPortalProps) {
	const context = useContext(TooltipPortalContext);
	if (context === null) {
		return null;
	}

	const container = document.getElementById(context.elementId);
	if (container === null) {
		return null;
	}

	return createPortal(props.children, container);
}
